import { render, staticRenderFns } from "./ProgramCurriculum.vue?vue&type=template&id=646c8c78"
import script from "./ProgramCurriculum.vue?vue&type=script&lang=js"
export * from "./ProgramCurriculum.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports